import { useEffect, useRef } from 'react';

const useInterval = (callback: () => void, timing: number, status: boolean) => {
	const referencedCallback = useRef<() => void>();
	useEffect(() => {
		referencedCallback.current = callback;
	}, [callback]);

	useEffect(() => {
		function fetchData() {
			referencedCallback.current();
		}
		if (timing !== null && status) {
			const id = setInterval(fetchData, timing);
			return () => {
				clearInterval(id);
			};
		}
	}, [callback, timing, status]);
};

export default useInterval;
